__turbopack_context__.v({
  "container": "oG-xSG_container",
  "gridContainer": "oG-xSG_gridContainer",
  "gridWithDrawer": "oG-xSG_gridWithDrawer",
  "groupName": "oG-xSG_groupName",
  "imageOnTopStyle": "oG-xSG_imageOnTopStyle",
  "menuGroupName": "oG-xSG_menuGroupName",
  "menuListingContainer": "oG-xSG_menuListingContainer",
  "productCard": "oG-xSG_productCard",
  "productListContainer": "oG-xSG_productListContainer",
  "subMenuGroupName": "oG-xSG_subMenuGroupName",
  "wrapper": "oG-xSG_wrapper",
});
